// extracted by mini-css-extract-plugin
export default {"message":"styles_message__TZ6le","message_container":"styles_message_container__T-ffO"};